// @section 1 ERP route — read-only cards over QBO views (placeholder until P5 sharpens views)
import { useEffect, useState } from 'react';
import { getCash, getRunway } from '../api';
import { useIsMobile } from '../lib/useIsMobile';

export default function Erp() {
  const [cash, setCash] = useState<any | null>(null);
  const [runway, setRunway] = useState<any | null>(null);
  // @block 1.1 Phone: own the scroll + add gutters (canvas is overflow:hidden).
  const isMobile = useIsMobile();

  useEffect(() => {
    getCash().then(setCash).catch(() => setCash({ rows: [], note: 'failed' }));
    getRunway().then(setRunway).catch(() => setRunway(null));
  }, []);

  return (
    <div style={isMobile ? { height: '100%', overflowY: 'auto', WebkitOverflowScrolling: 'touch', padding: '16px 14px' } : undefined}>
      <h1>ERP</h1>
      <p style={{ color: '#6b7a90', marginTop: 0 }}>
        Read-only views over QBO data. Views are placeholders today; P5 sharpens them once column shapes are confirmed.
      </p>
      <div className="cards">
        <div className="card">
          <h3>Cash position</h3>
          <div className="card-body">
            {cash === null ? <em>Loading…</em> : cash.rows.length === 0 ? <em>{cash.note ?? 'no data'}</em> : (
              <ul>{cash.rows.map((r: any, i: number) => <li key={i}>{r.as_of_date}: ${(r.cash_balance_cents / 100).toLocaleString()}</li>)}</ul>
            )}
          </div>
        </div>
        <div className="card">
          <h3>Runway</h3>
          <div className="card-body">
            {runway === null ? <em>Loading…</em> : (
              <>
                <div>Cash: ${(runway.cash_balance_cents / 100).toLocaleString()}</div>
                <div>Burn: ${(runway.monthly_burn_cents / 100).toLocaleString()}/mo</div>
                <div>Months: {runway.months_runway}</div>
                {runway.note && <small>{runway.note}</small>}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
